import graphql__967c0a97a93e71082696 from "./__generated__/PageSectionFeaturedContent_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import FeaturedContentGrid from "../FeaturedContent/FeaturedContentGrid";
import FeaturedContentCarousel from "../FeaturedContent/FeaturedContentCarousel";
import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";

const featuredContentDisplayModeTypes = {
  grid: FeaturedContentGrid,
  carousel: FeaturedContentCarousel
};

const PageSectionFeaturedContent = props => {
  const {
    title,
    iconClass,
    description,
    blocksDisplayMode,
    columnsRatio,
    columnsOrder,
    collapsible,
    collapsedHeight,
    featuredContentBlocks,
    sidebar
  } = props.pageSection;

  // Build actual rendering component name to be used in the returned component tree
  const FeaturedContentComponentName = featuredContentDisplayModeTypes[blocksDisplayMode];

  const hasFeaturedContentBlocks = featuredContentBlocks.length > 0;

  return (
    <div className="container page-section page-section-featured-content">
      <ContainerWithSidebar {...{ sidebar, columnsRatio, columnsOrder }}>
        <PageSectionBlockWithTitleAndDescription
          title={title}
          description={description}
          iconClassName={iconClass}
          collapsible={collapsible}
          collapsedHeight={collapsedHeight}
        >
          {hasFeaturedContentBlocks && (
            <FeaturedContentComponentName featuredContent={props.pageSection} />
          )}
        </PageSectionBlockWithTitleAndDescription>
      </ContainerWithSidebar>
    </div>
  );
};

export default createFragmentContainer(PageSectionFeaturedContent, {
  pageSection: graphql__967c0a97a93e71082696
});
